import React, { useEffect, useRef } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    AxisPointerComponent,
    TitleComponent,
    TimelineComponent,
    MarkPointComponent,
    MarkLineComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    VisualMapComponent,
    VisualMapContinuousComponent,
    VisualMapPiecewiseComponent,
} from 'echarts/components';
import {
    CanvasRenderer,
} from 'echarts/renderers';
import Button from '@material-ui/core/Button'
import StopValueSetting from './StopValueSetting'
import { getComputerOnlyDataZoom, getMobileTooltip, getComputerTooltip, getAxisPointer, getMobileDataZoom, getComputerDataZoom } from '../util/GridA'

echarts.use(
    [AxisPointerComponent, CanvasRenderer, VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, TitleComponent, TooltipComponent, GridComponent, LineChart, DataZoomComponent,
        DataZoomInsideComponent, DataZoomSliderComponent, MarkPointComponent, MarkLineComponent, TimelineComponent,
        LegendComponent]
);


const useStyles = makeStyles(theme => ({
    table: {
        // minWidth: 650,
        // overflowScrolling: 'touch',
        // WebkitOverflowScrolling: 'touch',  
        backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",      
    },
    root1: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    grid: {
        width: `calc(100% + ${6 + theme.spacing(1)}px)`
    }
}));


export default function StopValue(props) {
    const classes = useStyles();
    const theme = useTheme();

    const [options, setOptions] = React.useState(null)
    const [open1, setOpen] = React.useState(false);

    const [data, setData] = React.useState(null)
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        if (props.row != null) getPHV1()
    }, [props.row]);

    useEffect(() => {
        if (data != null) setOptions(genData1())
    }, [data]);

    const getPHV1 = () => {
        setLoading(true)
        let lic = localStorage.getItem('lic')

        // factor : Double = 3.0, days : Int = 20
        let factor = localStorage.getItem('factor') != null ? localStorage.getItem('factor') : 3.0
        let days = localStorage.getItem('days') != null ? localStorage.getItem('days') : 20


        if (lic != null) {
            let param = {
                lic: lic,
                sid: props.row.market_company.stock_no,
                factor: parseFloat(factor),
                days: days,
            };

            fetch("/jstock/v1/stop/get", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
                .then(res => res.json())
                .then(
                    result => {
                        setLoading(false)
                        if (result != null) {
                            setData(result)
                        }
                    }
                )

        }
    }


    const handleClose = () => {
        setOpen(false);
    };

    const handleOk = () => {
        getPHV1()
        setOpen(false);
    };




    // p.o, p.h, p.l, p.p
    //开盘(open)，收盘(close)，最低(lowest)，最高(highest)


    function yy() {
        return localStorage.getItem('pressa') === null ? "21日" : localStorage.getItem('pressa') + "日"
    }


    function genData1() {
        let option = {
            // legend: {
            //     data: ['昂貴區', '合理區', '便宜區', '股價',]
            // },
            grid: [
                {
                    top: '20',
                    left: '40',
                    right: '10',
                    height: '300',
                    borderWidth: 0,
                    borderColor: "#000205",
                    show: true
                }
            ],
            yAxis: [
                {
                    scale: true,
                    splitArea: {
                        show: false
                    },
                    show: true,
                    position: 'left',
                    splitLine: {
                        show: true
                    },
                }
            ],
        };

        let x1 = {
            type: 'category',
            scale: true,
            boundaryGap: true,
            data: data.atr.map(v => { return v.p.d }),
        }


        if (props.ismobile) {
            let k = {
                type: 'shadow',
                label: { show: false },
                triggerTooltip: true,
                handle: {
                    show: true,
                    margin: 25,
                    color: '#1868d9',
                    size: 30
                }
            }

            x1['axisPointer'] = k
        }

        option['xAxis'] = [x1]

        // p.o, p.p, p.l, p.h
        option['series'] = [
            {
                name: '日K',
                type: 'candlestick',
                data: data.atr.map(v => { return [v.p.o, v.p.p, v.p.l, v.p.h] }),
                itemStyle: {
                    color: "#d41c1c",
                    color0: '#65b206',
                    borderColor: "#d41c1c",
                    borderColor0: '#65b206'
                },
                selectedMode: 'single',
            },

            {
                name: '吊燈指標',
                type: 'line',
                data: data.atr.map(v => { return v.v }),
                endLabel: {
                    show: true
                },
                smooth: 'true',
                showSymbol: false,

            }


        ]

        if (props.ismobile) {
            option['tooltip'] = getMobileTooltip()
            option['axisPointer'] = getAxisPointer()
            option['dataZoom'] = getMobileDataZoom(80, 100)

        } else {
            option['tooltip'] = getComputerTooltip()
            option['axisPointer'] = getAxisPointer()
            option['dataZoom'] = getComputerOnlyDataZoom(70, 100)
        }

        return option
    }

    function getString() {
        return "目前無相關的吊燈移動出場指標圖"
    }

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <div>
            <StopValueSetting open={open1} handleClose={handleClose} handleOk={handleOk}></StopValueSetting>

            <Grid container spacing={3} className={classes.grid}>
                <Grid item xs={12} sm={12} >
                    <div style={{ display: 'flex', marginBottom: 5, paddingLeft: 0 }}>
                        <Typography className={classes.title} variant="h6" id="tableTitle">
                            吊燈移動出場指標<Button style={{ marginLeft: 2 }} size="small" color="primary" variant="outlined" onClick={(e) => handleOpen()}>設定</Button>
                        </Typography>
                    </div>
                    <div style={{ fontSize: 14, color: "#808080" }}>
                        用於判斷何時出場的指標。<br />
                        多頭出場：吊燈線需在K線的下方，一直到股價跌破吊燈線時出場。<br />
                        空頭出場：吊燈線需在K線的上方，一直到股價突破吊燈線時出場。<br />
                    </div>
                    {options != null ? <ReactEChartsCore
                        style={{ height: 350, marginTop: 20 }}
                        theme={theme.palette.type}
                        echarts={echarts}
                        option={options}
                        notMerge={true}
                        lazyUpdate={false}
                        showLoading={loading}
                    /> : <div style={{}}>{getString()}</div>}
                </Grid>
            </Grid>
        </div >
    );
}